module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1523-99fb3afff672526b9118cf4d07ad6d1f.png";